// React
import React from "react";
// React
// Components
import Spinner from "../../Utils/Spinner/Spinner";
// Components

type PendingManagerProps = {
  data: React.ReactNode;
  isPending: boolean;
};

const PendingManager: React.FunctionComponent<PendingManagerProps> = ({
  data,
  isPending,
}) => {
  return (
    <>
      {isPending ? (
        <div className="w-full flex items-center justify-center flex-col bg-purple-400 py-4">
          <p className=" w-max  text-xl py-4 rounded-lg ">در حال بارگذاری</p>
          <div className="flex flex-col items-center justify-center rounded-full">
            <Spinner className=" w-full" />
          </div>
        </div>
      ) : (
        <>{data}</>
      )}
    </>
  );
};

export default PendingManager;
